import { Intent, OverlayToaster, Position } from "@blueprintjs/core"

export const createToaster = ({
  message,
  intent,
  timeout = 3000,
}: {
  message: string
  intent: Intent
  timeout?: number
}) => {
  const toaster = OverlayToaster.create({
    position: Position.TOP,
  })
  toaster.show({
    message,
    intent,
    timeout,
  })
}

export const toaster = OverlayToaster.create({
  position: Position.TOP_RIGHT,
})
